<div class="popup-container w-[666px] max-mobile:w-unset">
    <div class="popup-header">
        <h2 class="font-bold text-xl text-neutral-07 flex flex-row items-center grow">
            {{ data.title }}
        </h2>
        <button (click)="handleClose()" type="button">
            <svg-icon class="icon-fill-neutral-04" src="/assets/icons/close.svg"></svg-icon>
        </button>
    </div>
    <div class="w-full border-b border-b-neutral-03"></div>

    <p *ngIf="data.isCreate" class="text-base font-semibold text-[#000000] my-3 max-mobile:px-4">
        Bạn có chắc muốn yêu cầu thêm
        <span class="font-bold">{{ formGroup.get('TopupAmount')?.value | numberFormat }}đ</span>
        ?
    </p>

    <form
        class="popup-body flex flex-col gap-3 max-h-[65vh] overflow-auto scrollbar-hover"
        [formGroup]="formGroup"
        (ngSubmit)="handleSubmit()"
        #ngForm="ngForm"
        [ngClass]="{ 'is-submited': ngForm.submitted }"
    >
        <div class="form-field">
            <label for="" class="field-required">Đại lý</label>
            <div
                class="mt-2 input-primary flex flex-row items-center rounded-lg bg-neutral-01 max-mobile:col-span-2"
                [ngClass]="{ 'field-invalid': formGroup.get('PartnerId')?.invalid }"
            >
                <pn-select
                    applyClass="py-3 px-4 !text-sm rounded-s-lg bg-transparent font-semibold placeholder:text-neutral-05 placeholder:font-normal "
                    class="grow"
                    placeholder="Chọn đại lý"
                    showSearch
                    readOnly
                    [options]="partnerOptions"
                    formControlName="PartnerId"
                >
                </pn-select>
            </div>
        </div>
        <div class="form-field">
            <label for="TopupAmount" class="field-required">Số tiền yêu cầu</label>
            <p-inputNumber
                formControlName="TopupAmount"
                class="grow mt-2"
                [inputStyleClass]="
                    'px-4 py-[10px] input-primary rounded-lg shadow-none !text-sm font-semibold placeholder:text-neutral-05 placeholder:font-normal w-full '.concat(
                        formGroup.get('TopupAmount')?.invalid ? 'field-invalid' : ''
                    )
                "
                placeholder="Nhập số tiền yêu cầu"
            />

        </div>
        <div class="form-field">
            <label for="Content" class="field-required">Nội dung chi tiết</label>
            <div
                class="mt-4 w-full py-[11px] px-4 input-primary rounded-[15px] flex flex-row"
                [ngClass]="{
                    'field-invalid': formGroup.get('Content')?.invalid
                }"
            >
                <svg-icon
                    class="mr-3 transition-all duration-300 ease-in-out"
                    [ngClass]="{
                        hidden: formGroup.get('Content')?.value,
                        'field-invalid fill': formGroup.get('Content')?.invalid
                    }"
                    [svgStyle]="{ 'width.px': 24, 'height.px': 24 }"
                    src="/assets/icons/edit-4.svg"
                ></svg-icon>
                <textarea
                    class="w-full resize-none outline-none text-sm font-semibold text-neutral-07 placeholder:font-normal bg-transparent scrollbar-hover max-mobile:text-base"
                    rows="4"
                    placeholder="Nhập nội dung mô tả"
                    formControlName="Content"
                    pnFocusIntoView
                ></textarea>
            </div>
        </div>
    </form>

    <div class="popup-footer max-mobile:!grid max-mobile:grid-cols-2">
        <button
            class="!font-bold w-[146px] text-center max-mobile:!py-[9px] max-mobile:col-span-1 max-mobile:w-full"
            pnButton
            outline
            rounded="lg"
            (click)="handleClose()"
        >
            Đóng
        </button>
        <button
            class="!font-bold w-[146px] max-mobile:w-full text-center flex items-center justify-center max-mobile:!py-[10px] max-mobile:col-span-1"
            pnButton
            rounded="lg"
            (click)="ngForm.onSubmit($event)"
        >
            <svg-icon
                *ngIf="loading()"
                class="icon:fill-neutral-01 mr-1 transition-all duration-300"
                svgClass="animate-spin"
                [svgStyle]="{
                    'width.px': 20,
                    'height.px': 20
                }"
                src="/assets/icons/loading.svg"
            ></svg-icon>
            Lưu
        </button>
    </div>
</div>
